import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { heroImages, photos } from "../data/mock";
import { useSpeciesList } from "../i18n/content";
import { PageHero, SpeciesCard, Reveal, CTASection } from "../components/common";
import { Button } from "../components/ui/button";
import Seo from "../components/Seo";

const SpeciesList = ({ zone }) => {
  const { t } = useTranslation();
  const c = t(`speciesList.${zone}`, { returnObjects: true });
  const species = useSpeciesList();
  const list = species.filter((s) => s.zone === zone);
  const other = zone === "offshore" ? "inshore" : "offshore";
  return (
    <>
      <Seo
        title={`${c.title} — Sport Fishing Charters | Hog Tide`}
        description={`${c.sub} Book a private Hog Tide ${zone} fishing charter in San Juan del Sur, Nicaragua.`}
        path={`/${zone}-species`}
      />
      <PageHero image={zone === "offshore" ? heroImages[1].img : zone === "bottom" ? photos.doradoShirtless : "https://customer-assets-4nw71qhi.emergentagent.net/job_sjds-fishing-trips/artifacts/v950tkt7_image.png"} eyebrow={c.eyebrow} title={c.title} sub={c.sub} />
      <section className="py-14">
        <div className="container-x">
          <p className="text-slate-300 max-w-3xl mb-10 leading-relaxed">{c.intro}</p>
          <div className="grid gap-5 sm:grid-cols-2 lg:grid-cols-3">
            {list.map((s, i) => (<Reveal key={s.slug} delay={(i % 3) * 0.06}><SpeciesCard s={s} /></Reveal>))}
          </div>
          <div className="flex flex-wrap gap-3 mt-10">
            <Link to={`/${other}-species`}><Button variant="outline" className="border-white/20 bg-transparent text-white hover:bg-white/10 hover:text-white capitalize">{t("speciesList.seeOther", { zone: t(`plan.${other}`) })}</Button></Link>
            <Link to="/fishing-calendar"><Button variant="outline" className="border-white/20 bg-transparent text-white hover:bg-white/10 hover:text-white">{t("speciesList.fishingCalendar")}</Button></Link>
            <Link to="/plan-your-trip"><Button className="btn-gold">{t("speciesList.planYourTrip")}</Button></Link>
          </div>
        </div>
      </section>
      <CTASection image={heroImages[0].img} />
    </>
  );
};

export default SpeciesList;
